<script setup>
import {
  defineProps,
  ref,
  nextTick,
  onMounted,
  onBeforeUnmount,
  computed,
  defineEmits,
} from "vue";
import { hasRTLDirection } from "@/utils/common";
defineProps({
  config: {
    type: Object,
    default: () => {
      return {};
    },
  },
});
const isArSite = ref(hasRTLDirection());
const activeAreaId = ref(0);
const translateX = ref(0);
const wrapperWidth = ref(0);
const showLeftButton = ref(false);
const showRightButton = ref(false);
const currentVisibleIndex = ref(0);
const navWrapper = ref(null);
const navItems = ref(null);
const startX = ref(0);
const endX = ref(0);
const delta = ref(0);
const isCanScroll = ref(false);
const isScolling = ref(false);
const marginRight = ref(0);
const btn_left = ref(null);
const btn_right = ref(null);

const isok = ref(false);
const $emit = defineEmits(["itemClick"]);

const isLastItemVisible = computed(() => {
  return checkLastItemVisibility();
});

const isCanMove = () => {
  const navItemsWidth = navItems.value.reduce(
    (acc, cur) => acc + cur.offsetWidth + marginRight.value,
    0
  );
  return navItemsWidth - marginRight.value > wrapperWidth.value;
};

onMounted(() => {
  calculateWrapperWidth();
  window.addEventListener("resize", calculateWrapperWidth);
  // 初始检查按钮状态
  updateButtonState();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", calculateWrapperWidth);
});

const handleClickArea = (item, index) => {
  activeAreaId.value = index;
  $emit("itemClick", item, index);
};

const calculateWrapperWidth = () => {
  nextTick(() => {
    wrapperWidth.value = navWrapper.value.offsetWidth;
    if (isArSite.value) {
      marginRight.value = parseFloat(
        window.getComputedStyle(navItems.value[0]).marginLeft
      );
    } else {
      marginRight.value = parseFloat(
        window.getComputedStyle(navItems.value[0]).marginRight
      );
    }
    isCanScroll.value = isCanMove();
    updateButtonState();
  });
};

const getItemWidth = (index) => {
  if (!navItems.value || index < 0 || index >= navItems.value.length) {
    return 0;
  }
  return navItems.value[index].offsetWidth + marginRight.value; // 包括margin
};
const scrollLeft = () => {
  if (currentVisibleIndex.value <= 0) {
    return;
  }

  isScolling.value = true;
  // 获取前一个项的宽度
  const prevItemWidth = getItemWidth(currentVisibleIndex.value - 1);
  translateX.value += prevItemWidth;
  currentVisibleIndex.value--;
  if (currentVisibleIndex.value === 0) {
    translateX.value = 0;
    isok.value = false;
  }
  console.log("currentItemWidth", currentVisibleIndex.value);

  // 更新按钮状态
  updateButtonState();
};
const scrollRightrtl = ()=>{
  if (currentVisibleIndex.value <= 0) {
    return;
  }

  isScolling.value = true;
  // 获取前一个项的宽度
  const prevItemWidth = getItemWidth(currentVisibleIndex.value - 1);
  translateX.value -= prevItemWidth;
  currentVisibleIndex.value--;
  if (currentVisibleIndex.value === 0) {
    translateX.value = 0;
    isok.value = false;
  }
  console.log("currentItemWidth", currentVisibleIndex.value);

  // 更新按钮状态
  updateButtonState();
}
const scrollLeftrtl = () => {
  if (currentVisibleIndex.value >= navItems.value.length - 1) {
    return;
  }
  // 获取当前项的宽度
  isScolling.value = true;
  const currentItemWidth = getItemWidth(currentVisibleIndex.value);
  console.log("currentItemWidth", currentVisibleIndex.value);
  translateX.value += currentItemWidth;
  currentVisibleIndex.value++;
  // 更新按钮状态
  updateButtonState();
};
const scrollRight = () => {
  if (currentVisibleIndex.value >= navItems.value.length - 1) {
    return;
  }
  // 获取当前项的宽度
  isScolling.value = true;
  const currentItemWidth = getItemWidth(currentVisibleIndex.value);
  console.log("currentItemWidth", currentVisibleIndex.value);
  translateX.value -= currentItemWidth;
  currentVisibleIndex.value++;
  // 更新按钮状态
  updateButtonState();
};

const getUlleftNumber = (ulEl) => {
  const liList = ulEl.querySelectorAll("li");
  let total = 0;
  liList.forEach((li) => {
    // 获取li自身宽度（offsetWidth：内容+padding+border）
    const liWidth = li.offsetWidth;
    // 获取计算后的margin-left值（转数字，处理'auto'/'0px'等情况）
    const marginLeft = parseFloat(getComputedStyle(li).marginLeft) || 0;
    // 累加当前li的总和
    total += liWidth + marginLeft;
  });

  return total;
};

const updateButtonState = () => {
  nextTick(() => {
    if (isArSite.value) {
      showRightButton.value = translateX.value > 0;
      showLeftButton.value = !isLastItemVisible.value;
      isScolling.value = false;
      if (showRightButton.value && !isok.value) {
        isok.value = true;
        translateX.value -= $(btn_right.value).width();
      }
    } else {
      showLeftButton.value = translateX.value < 0;
      showRightButton.value = !isLastItemVisible.value;
      isScolling.value = false;
      if (showLeftButton.value && !isok.value) {
        isok.value = true;
        translateX.value += $(btn_left.value).width();
      }
    }
  });
};

const checkLastItemVisibility = () => {
  if (!navItems.value || !navItems.value.length) {
    return false;
  }
  if (isArSite.value) {
    const lastItem = navItems.value[0];
    const lastItemRight =
      getUlleftNumber(lastItem.parentElement) - lastItem.offsetWidth + $(btn_right.value).width() + + $(btn_left.value).width();
    const visibleRight = Math.abs(translateX.value) + wrapperWidth.value;
    console.log(
      "lastItemRight1111",
      lastItemRight,
      visibleRight,
      marginRight.value
    );
    return lastItemRight <= visibleRight - marginRight.value;
  } else {
    const lastItem = navItems.value[navItems.value.length - 1];
    const lastItemRight = lastItem.offsetLeft + lastItem.offsetWidth;
    console.log(
      "lastItemRight",
      lastItemRight,
      lastItem.offsetLeft,
      lastItem.offsetWidth
    );
    const visibleRight = Math.abs(translateX.value) + wrapperWidth.value;
    return lastItemRight <= visibleRight - marginRight.value;
  }
};

const handleTouchStart = (e) => {
  startX.value = e.touches[0].clientX;
};

const handleTouchMove = (e) => {
  endX.value = e.touches[0].clientX;
  delta.value = endX.value - startX.value;
};

const handleTouchEnd = () => {
  endX.value = 0;
  if (delta.value === 0 || isScolling.value) {
    return;
  }
  if (delta.value > 0) {
    isCanScroll.value && scrollLeft();
  } else {
    isCanScroll.value && showRightButton.value && scrollRight();
  }
  delta.value = 0;
};
</script>

<template>
  <div
    ref="navWrapper"
    class="csr-wtb-dialog__retailers__country-wrap"
    @touchstart="handleTouchStart"
    @touchmove="handleTouchMove"
    @touchend="handleTouchEnd"
  >
    <i
      v-if="isArSite"
      v-show="showRightButton"
      class="nav-btn nav-btn-right"
      @click="scrollRightrtl"
      ref="btn_right"
    />
    <i
      v-else
      v-show="showLeftButton"
      ref="btn_left"
      class="nav-btn nav-btn-left"
      @click="scrollLeft"
    />
    <ul
      class="csr-wtb-dialog__retailers__country"
      :class="!showLeftButton ? 'no_padding' : ''"
      :style="{ transform: `translateX(${translateX}px)` }"
    >
      <li
        v-for="(item, index) in config.retailerGroup"
        :key="'areaName' + index"
        ref="navItems"
        class="csr-wtb-dialog__retailers__country__item"
        :class="[activeAreaId === index ? 'active' : '']"
        @click="handleClickArea(item, index)"
      >
        {{ item.areaName }}
      </li>

      <!-- <li
        v-for="(item, index) in config.retailerGroup"
        :key="'areaName' + index"
        ref="navItems"
        class="csr-wtb-dialog__retailers__country__item"
        :class="[activeAreaId === index ? 'active' : '']"
        @click="handleClickArea(item, index)"
      >
        {{ item.areaName }}
      </li>

      <li
        v-for="(item, index) in config.retailerGroup"
        :key="'areaName' + index"
        ref="navItems"
        class="csr-wtb-dialog__retailers__country__item"
        :class="[activeAreaId === index ? 'active' : '']"
        @click="handleClickArea(item, index)"
      >
        {{ item.areaName }}
      </li>

      <li
        v-for="(item, index) in config.retailerGroup"
        :key="'areaName' + index"
        ref="navItems"
        class="csr-wtb-dialog__retailers__country__item"
        :class="[activeAreaId === index ? 'active' : '']"
        @click="handleClickArea(item, index)"
      >
        {{ item.areaName }}
      </li>

      <li
        v-for="(item, index) in config.retailerGroup"
        :key="'areaName' + index"
        ref="navItems"
        class="csr-wtb-dialog__retailers__country__item"
        :class="[activeAreaId === index ? 'active' : '']"
        @click="handleClickArea(item, index)"
      >
        {{ item.areaName }}
      </li>

      <li
        v-for="(item, index) in config.retailerGroup"
        :key="'areaName' + index"
        ref="navItems"
        class="csr-wtb-dialog__retailers__country__item"
        :class="[activeAreaId === index ? 'active' : '']"
        @click="handleClickArea(item, index)"
      >
        {{ item.areaName }}
      </li> -->
    </ul>
    <i
      v-if="isArSite"
      v-show="showLeftButton"
      ref="btn_left"
      class="nav-btn nav-btn-left"
      @click="scrollLeftrtl"
    />
    <i
      v-else
      v-show="showRightButton"
      class="nav-btn nav-btn-right"
      @click="scrollRight"
    />
  </div>
</template>
